// extracted by mini-css-extract-plugin
export var details = "_fu-0";
export var inspectorPopover = "_fu-1";